import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RvDividerComponent } from '../../divider/divider.component';
import { MatInputModule } from '@angular/material/input';
import { FoldersApiService } from 'src/app/api/services/folders-api.service';
import { RvSpinnerDirective } from '../../loading/rv-spinner.directive';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { FolderPathComponent } from '../folder-path/folder-path.component';
import { NewFolderButtonComponent } from '../new-folder-button/new-folder-button.component';
import {
  FolderListItem,
  MoveFolderDialogService,
} from '../services/move-folder-dialog.service';
import { RvButtonComponent } from '../../button/button.component';

@Component({
  selector: 'move-folder-dialog',
  templateUrl: './move-folder-dialog.component.html',
  styleUrls: ['./move-folder-dialog.component.scss'],
  imports: [
    RvButtonComponent,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    RvDividerComponent,
    MatCheckboxModule,
    SearchFilterComponent,
    RvSpinnerDirective,
    NewFolderButtonComponent,
    FolderPathComponent,
  ],
  providers: [MoveFolderDialogService],
})
export class MoveFolderDialogComponent {
  protected search = {
    query: '',
  };
  protected doSearch = () => {
    this.selectFolderDialogService.updateFolderList({
      kind: this.data.kind,
      folderId: this.data.folderId,
      search: this.search.query,
    });
  };
  protected filterConfig: { placeholder: string };

  constructor(
    public dialogRef: MatDialogRef<MoveFolderDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      kind: 'Display' | 'Schedule' | 'Presentation';
      folderId: string;
      parentId?: string;
      folders?: string[];
    },
    protected selectFolderDialogService: MoveFolderDialogService,
  ) {
    this.selectFolderDialogService.initTree(this.data.kind);
    this.selectFolderDialogService.updateFolderList({
      kind: this.data.kind,
      folderId: this.data.folderId,
      parentId: this.data.parentId,
    });
    this.filterConfig = {
      placeholder: `Search Folders`,
    };
  }

  protected selectFolder(folder: FolderListItem) {
    this.selectFolderDialogService.handleFolderSelection(folder);
  }

  protected enterFolder(folder: Pick<FolderListItem, 'id'>) {
    if (this.shouldDisable(folder.id)) {
      return;
    }
    this.search.query = '';
    this.selectFolderDialogService.updateFolderList({
      kind: this.data.kind,
      parentId: folder.id,
      search: this.search.query,
      folderId: this.data.folderId,
    });
  }

  protected handleFolderCreated() {
    this.search.query = '';
    this.selectFolderDialogService.updateFolderList({
      kind: this.data.kind,
      folderId: this.data.folderId,
      parentId: this.selectFolderDialogService.currentParentFolderId,
      search: this.search.query,
    });
  }

  protected moveFolder() {
    const selectedFolder = this.someFolderIsSelected
      ? this.selectFolderDialogService
          .folders()
          ?.find((folder) => folder.isSelected).id
      : this.selectFolderDialogService.currentParentFolderId ||
        FoldersApiService.ROOT_FOLDER_ID;

    this.dialogRef.close(selectedFolder);
  }

  protected get someFolderIsSelected() {
    return this.selectFolderDialogService
      .folders()
      .some((folder) => folder.isSelected);
  }

  shouldDisable(id: string) {
    return this.data.folders?.includes(id);
  }
}
